import { Injectable } from '@angular/core';
import { StatsigService } from '@services/statsig.service';
import { isRemoteLoginSession } from '@lib/remote-login';

export enum SESSION_FLAGS {
  SAFETY_VIDEO_RECALL_MANAGE_PERMISSION_ENABLED = 'safety-video-recall-manage-permission-enabled',
  SAFETY_BEHAVIOR_TAGS_PERMISSION_ENABLED = 'safety-behavior-tags-severity-modification-enabled',
  REMOTE_LOGIN_VIDEO_DOWNLOAD_ENABLED = 'remote-login-video-download-enabled',
  SAFETY_FULL_DRIVER_PRIVACY_PERMISSION_ENABLED = 'safety-full-driver-privacy-permission-enabled',
}

@Injectable({ providedIn: 'root' })
export class SessionFeatureFlagService {
  constructor(private statsigService: StatsigService) {}

  public isVideoRecallManagePermissionEnabled(): boolean {
    return this.statsigService.evaluateGate(SESSION_FLAGS.SAFETY_VIDEO_RECALL_MANAGE_PERMISSION_ENABLED);
  }

  public isSafetyBehaviorTagsPermissionEnabled(): boolean {
    return this.statsigService.evaluateGate(SESSION_FLAGS.SAFETY_BEHAVIOR_TAGS_PERMISSION_ENABLED);
  }

  public isRemoteLoginVideoDownloadEnabled(): boolean {
    return !isRemoteLoginSession() || this.statsigService.evaluateGate(SESSION_FLAGS.REMOTE_LOGIN_VIDEO_DOWNLOAD_ENABLED);
  }

  public isFullDriverPrivacyEnabled(): boolean {
    return this.statsigService.evaluateGate(SESSION_FLAGS.SAFETY_FULL_DRIVER_PRIVACY_PERMISSION_ENABLED);
  }
}
